import { MijnRoute } from '../../mijn-navigatie.model';

export const SELF_SERVICE_ADD_PRODUCT: MijnRoute = {
    path: 'product-toevoegen',
    navigationEvent: 'toProductToevoegen',
    regex: /^\/zelf-regelen\/product-toevoegen$/,
    webcomponent: 'mijn-klant-zelfservice-webcomponent',
    internalPath: '/product-toevoegen'
};
